export interface SummaryButton {
  text: string;
  image?: string;
  icon?: string;
  cssClass?: string;
  click?: () => void;
}
